// import React, { useEffect, useState } from "react";
// import {
//   CallControls,
//   StreamCall,
//   StreamTheme,
//   StreamVideo,
//   SpeakerLayout,
//   StreamVideoClient,
// } from "@stream-io/video-react-sdk";
// import { useLocation } from "react-router-dom"; // Assuming you're using React Router for navigation

// import "@stream-io/video-react-sdk/dist/css/styles.css";
// import "./lawyerVideo.css";

// export default function LawyerVideo() {
//   const location = useLocation();
//   const [client, setClient] = useState(null);
//   const [call, setCall] = useState(null);

//   // Extracting URL parameters for token, userId, callId, and name
//   const params = new URLSearchParams(location.search);
//   const token = JSON.parse(params.get("token")); // Extract token
//   const userId = JSON.parse(params.get("userId")); // Extract userId
//   const callId = JSON.parse(params.get("callId")); // Extract callId
//   const name = JSON.parse(params.get("name")); // Extract name

//   // User object (as per the demo)
//   const user = {
//     id: userId,
//     name: name,
//     image: "https://getstream.io/random_svg/?id=oliver&name=Oliver", // Default image URL
//   };

//   const apiKey = "r2np5pp6p7w7"; // Your Stream API key

//   useEffect(() => {
//     // Initialize the StreamVideoClient (this is similar to the demo code)
//     const myClient = new StreamVideoClient({ apiKey, user, token });
//     setClient(myClient);

//     // Cleanup the client when component unmounts
//     return () => {
//       myClient.disconnectUser();
//       setClient(null);
//     };
//   }, []); // Empty dependency array: this effect runs only once when the component mounts

//   useEffect(() => {
//     if (!client || !callId) return;

//     // Create the call and join it
//     const myCall = client.call("default", callId);
//     myCall.join({ create: true }).catch((err) => {
//       console.error("Failed to join the call", err);
//     });

//     // Set the call state
//     setCall(myCall);

//     // Cleanup the call on component unmount
//     return () => {
//       setCall(null);
//       myCall.leave().catch((err) => {
//         console.error("Failed to leave the call", err);
//       });
//     };
//   }, [client]); // Only re-run this effect if client or callId changes

//   // Show loading until the client and call are ready
//   if (!client || !call) return <div>Loading...</div>;

//   return (
//     <StreamVideo client={client}>
//       <StreamTheme className="my-theme-overrides">
//         <StreamCall call={call}>
//           <SpeakerLayout />
//           <CallControls />
//         </StreamCall>
//       </StreamTheme>
//     </StreamVideo>
//   );
// }

// LawyerVideo.jsx
import React, { useEffect, useState } from "react";
import {
  StreamVideo,
  StreamTheme,
  StreamCall,
  StreamVideoClient,
  SpeakerLayout,
  CallControls,
} from "@stream-io/video-react-sdk";
import { useLocation } from "react-router-dom";

import "@stream-io/video-react-sdk/dist/css/styles.css";
import "./lawyerVideo.css";

export default function LawyerVideo() {
  const location = useLocation();

  const [client, setClient] = useState(null);
  const [call, setCall] = useState(null);
  // Extracting URL parameters for token, userId, callId, and name
  const params = new URLSearchParams(location.search);
  const token = JSON.parse(params.get("token")); // Extract token
  const userId = JSON.parse(params.get("userId")); // Extract userId
  const callId = JSON.parse(params.get("callId")); // Extract callId
  const name = JSON.parse(params.get("name")); // Extract name

  // User object (as per the demo)
  const user = {
    id: userId,
    name: name,
    image: "https://getstream.io/random_svg/?id=oliver&name=Oliver", // Default image URL
  };

  const apiKey = "r2np5pp6p7w7"; // Your Stream API key

  // 1. init StreamVideoClient
  useEffect(() => {
    if (!token) return console.error("Missing Stream token");
    const vClient = new StreamVideoClient({ apiKey, user, token });
    setClient(vClient);
    return () => {
      vClient.disconnectUser();
      setClient(null);
    };
  }, [token]);

  // 2. join the call
  useEffect(() => {
    if (!client || !callId) return;
    const vCall = client.call("default", callId);
    vCall.join({ create: true }).catch(console.error);
    setCall(vCall);
    return () => {
      vCall.leave().catch(console.error);
      setCall(null);
    };
  }, [client, callId]);

  // 3. best-effort leave on tab close/reload
  useEffect(() => {
    if (!call) return;
    const handler = (e) => {
      call.leave().catch(() => {});
      e.preventDefault();
      e.returnValue = "";
    };
    window.addEventListener("beforeunload", handler);
    return () => window.removeEventListener("beforeunload", handler);
  }, [call]);

  if (!client || !call) return <div>Loading…</div>;

  // Called after Stream has left the call (either Leave or End-for-everyone)
  const leaveAndClose = () => {
    // close the tab once the SDK has fully left
    window.close();
  };

  return (
    <StreamVideo client={client}>
      <StreamTheme className="my-theme-overrides">
        <StreamCall call={call}>
          <SpeakerLayout />

          {/* keep the built-in controls, but add onLeave to close the tab */}
          <CallControls onLeave={leaveAndClose} />
        </StreamCall>
      </StreamTheme>
    </StreamVideo>
  );
}
